import { buildHashParameters, getHashParameters } from '@imaios-js/utils';

/**
 * Set the editing scope in the current history entry.
 * @see https://developer.mozilla.org/en-US/docs/Web/API/History
 * @param editScope {string} the name of the editing scope
 * @param hash {string} the hash of the edited taxon
 */
export function setEditState(editScope, hash) {
	// set the scope in the fragment
	const url = new URL(window.location.href);

	const hashList = getHashParameters(window.location.href);
	hashList.set(editScope, hash);
	url.hash = buildHashParameters(hashList);

	window.history.replaceState(window.history.state, '', url);
}

/**
 * Clear the editing scope from both the fragment and the history state
 * @see https://developer.mozilla.org/en-US/docs/Web/API/History
 */
export function unsetEditState(editScope) {
	// remove any existing fragment from the URL
	const url = new URL(window.location.href);

	const hashList = getHashParameters(window.location.href);
	hashList.delete(editScope);
	url.hash = buildHashParameters(hashList);

	// set the URL and clean the history state
	window.history.replaceState(window.history.state, '', url);
}

/**
 * Check the URL's fragment (the part after the #) for a potential edit state.
 * @param editScope {string} the name of the editing scope
 * @return {boolean}
 */
export function hasEditState(editScope) {
	try {
		return getHashParameters(window.location.href).has(editScope);
	}
		// if for some reason the location's href can't be parsed return false, this should never happen tho
	catch (e) {
		return false;
	}
}


/**
 *
 * @param editScope {string} the name of the editing scope
 * @return {string|null} the hash of the edited taxon if the editing scope matches `editScope`
 */
export function getHashFromState(editScope) {
	try {
		if (!hasEditState(editScope)) {
			return null;
		}

		return getHashParameters(window.location.href).get(editScope) ?? null;
	}
		// if for some reason the location's href can't be parsed return false, this should never happen tho
	catch (e) {
		return null;
	}
}
